import { IReduxState } from 'types/redux';

export const zoneGuardsOccupancySelector = (state: IReduxState) => state.zoneGuardsOccupancy.occupancies.map;

export const zoneGuardsMusteringSelector = (state: IReduxState) => state.zoneGuardsOccupancy.mustering.map;
